"use client";
import React, { useEffect } from "react";
import Header from "../Profile/Header";
import Footer from "../Footer";
import { useNavigate } from "react-router-dom";


const Terms = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // scroll to top when page mounts
  }, []);
const navigate = useNavigate();
const handleNavigation = (path) => navigate(path);

  return (
    <div>
      {/* <div className="w-full">
        <Header />
      </div> */}

      <main className="flex pb-8 w-full min-h-screen bg-[#fff8ef] mt-10 max-xl:flex-col max-xl:gap-5 max-md:p-5 max-sm:p-4">
        <section className="flex flex-col flex-1 gap-5 min-w-0">
          <div className="bg-[#fff8ef] min-h-screen ">
            

            {/* Card */}
            <div className="bg-white rounded-2xl shadow-lg p-8 max-w-5xl mx-auto">
              {/* Logo + Title */}
              <div className="flex items-center justify-center gap-3 mb-8">
  <div
            className=" text-3xl sm:text-3xl md:text-3xl lg:text-4xl 
      font-bold leading-none text-black 
      tracking-[1px] md:tracking-[2px] 
      hover:opacity-80 transition-opacity duration-200 
      flex-shrink-0 min-w-0
      
      lg:[-webkit-text-stroke:2px_gray-700]"
            
            aria-label="Manaprint Home"
          >
           
    Terms & Conditions
  </div>
</div>

              {/* Content */}
              <div className="space-y-5 text-gray-700 leading-relaxed">
                <h1>
                  These Terms & Conditions (“Terms”) govern your access to and use of
                  custom-print design and product services provided by Manaprint,
                  including our website, design tools, ordering, production,
                  delivery, and account services (collectively, the “Service”).
                  By placing an order or using the Service you accept and agree to
                  be bound by these Terms.
                </h1>

                <p>
                  Manaprint offers custom-printed goods such as fridge magnets, photo
                  frames, mobile cases, desk decorations, wall decorations, and related
                  personalized products. These Terms apply to all customers (“Customers”)
                  and to all purchases, custom designs, and services provided through the
                  Site or mobile app.
                </p>

                <p>
                  <strong>1. Orders, Proofs & Custom Designs</strong>
                  <br />
                  When you submit artwork, text, photos, or other media for printing, you
                  represent that you own or have the right to use the submitted materials.
                  Manaprint may provide a digital proof for customer approval prior to production.
                  You must review proofs carefully: once you approve a proof or place a final
                  order without requesting changes, production will begin and errors caused by
                  approved proofs or submitted content are your responsibility.
                </p>

                <p>
                  <strong>2. Pricing, Payment & Billing</strong>
                  <br />
                  Prices are displayed in your selected currency and include product and
                  production charges; shipping and taxes may be added at checkout. Payment
                  is required at the time of order. Manaprint accepts the payment methods
                  shown at checkout and may use third-party processors. All charges are final
                  after order confirmation except as otherwise required by law or by Manaprint’s
                  refund policy.
                </p>

                <p>
                  <strong>3. Production & Delivery</strong>
                  <br />
                  Production and delivery timelines vary by product, customization complexity,
                  and shipping destination. Estimated shipping dates are provided at checkout
                  and are not guaranteed. Customers must provide accurate shipping information.
                  Risk of loss and title transfer to the carrier upon shipment. If an item is
                  damaged in transit, contact Manaprint and the carrier promptly.
                </p>

                <p>
                  <strong>4. Returns, Refunds & Replacements</strong>
                  <br />
                  Because products are custom-produced to your specifications, returns are
                  limited. If an item arrives defective, damaged, or materially not as shown
                  in the approved proof, Manaprint will, at its discretion, replace the item
                  or issue a refund. To request a replacement or refund, you must notify us
                  within the timeframe stated in our Returns Policy and provide photos of the problem.
                </p>

                <p>
                  <strong>5. Usage, Safety & Customer Responsibility</strong>
                  <br />
                  Customers are responsible for selecting appropriate product materials,
                  finishes, and uses — particularly for items intended for children or for
                  display in environments where durability or safety is critical. Ensure that
                  designs do not contain prohibited content (illegal content, hate speech,
                  explicit sexual content, or third-party intellectual property you do not own).
                  Manaprint reserves the right to refuse or cancel any order containing
                  prohibited or infringing content.
                </p>

                <p>
                  <strong>6. Damaged, Lost, or Incorrect Orders</strong>
                  <br />
                  If an order is lost or arrives damaged, notify Manaprint with order details
                  and photographic evidence. Manaprint may require additional information to
                  investigate and will work to provide a remedy such as a replacement or refund
                  when appropriate. Manaprint is not responsible for delays or losses caused by
                  carriers or circumstances outside our control.
                </p>

                <p>
                  <strong>7. Intellectual Property</strong>
                  <br />
                  All content on the Site, including templates, product images, UI and code,
                  are the property of Manaprint or its licensors. By submitting your designs you
                  grant Manaprint a non-exclusive, worldwide license to use your submitted content
                  for fulfilling orders, quality checks, and for marketing (only if you give explicit consent).
                </p>

                <p>
                  <strong>8. Limitation of Liability</strong>
                  <br />
                  To the fullest extent permitted by law, Manaprint’s liability for any claim
                  arising out of or relating to these Terms or the Service will be limited to the
                  amount actually paid by you for the specific order that gives rise to the claim.
                  Manaprint is not liable for indirect, incidental, special, punitive, or
                  consequential damages.
                </p>

                <p>
                  <strong>9. Account Suspension & Cancellation</strong>
                  <br />
                  Manaprint may suspend or cancel orders or accounts for suspected fraud, payment
                  problems, or violation of these Terms. Customers remain responsible for charges
                  incurred prior to cancellation.
                </p>

                <p>
                  <strong>10. Governing Law & Dispute Resolution</strong>
                  <br />
                  These Terms are governed by the laws of the jurisdiction where Manaprint primarily
                  operates. Any disputes will be resolved in that jurisdiction’s courts unless otherwise
                  agreed in writing.
                </p>

                <p>
                  <strong>11. Changes to Terms</strong>
                  <br />
                  Manaprint may modify these Terms at any time. Changes will be posted on the Site
                  and will become effective at the posted effective date. Continued use of the Service
                  after changes constitutes acceptance of the updated Terms.
                </p>

                <p>
                  <strong>12. Contact</strong>
                  <br />
                  For questions about these Terms or Manaprint services please contact:
                  <br />
                  Email: <strong>manaprint6@gmail.com</strong>
                  <br />

                </p>

                <p>
                  By placing an order with Manaprint, you acknowledge that you have read, understood,
                  and agree to these Terms & Conditions.
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Terms;
